import { render } from "./NotFound.vue?vue&type=template&id=45b586d3"
const script = {}

import exportComponent from "C:\\Users\\kevin\\Documents\\GitHub\\my_page\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__